module.exports = __webpack_public_path__ + "media/images/instagram-grid-6f580183415aecfeffe22e10edc29cf3.png";